<template>
  <div class="tw:bg-blue-200 tw:text-blue-800 tw:rounded-xl tw:gap-y-[2px] tw:py-4 tw:px-5">
    <h5 class="tw:text-sm tw:font-bold" v-html="$t(title)" />
    <p class="tw:text-sm" v-html="$t(text)" />
  </div>
</template>
<script setup>
defineProps({
  title: String,
  text: String,
})
</script>
